import { useState, useEffect } from 'react';

type TransitionStatus = 'entering' | 'exiting' | 'none';

export function useTransitionAnimation(duration?: number) {
  const [status, setStatus] = useState<TransitionStatus>('none'); // Stato dell'animazione
  const [isVisible, setIsVisible] = useState<boolean>(false); // Stato di apertura

  // Funzione per aprire la modal
  const open = () => {
    setIsVisible(true);
    setStatus('entering'); // Inizia animazione di ingresso
  };

  // Funzione per chiudere la modal
  const close = () => {
    setStatus('exiting'); // Inizia animazione di uscita
  };

  // Gestione quando l'animazione è finita (per chiudere definitivamente la modal)
  useEffect(() => {
    if (status === 'exiting') {
      const timeout = setTimeout(() => {
        setIsVisible(false); // Nascondi la modal completamente dopo l'animazione di uscita
        setStatus('none'); // Reset dello stato di animazione
      }, duration || 300); // Durata dell'animazione

      return () => clearTimeout(timeout); // Cleanup del timeout se il componente è smontato
    }
  }, [duration, status]);

  return {
    isVisible,
    status,
    open,
    close,
  };
}
